import { FC } from 'react';
import { useRouteParams } from 'utils/useIdParam';
import { ROUTES } from 'config';
import { useAdminClient } from 'store/admin-clients';
import {
  AdminClientDepositHistoryListPerClient,
  AdminClientDepositHistoryListPerCompany,
} from './atoms';

export const AdminClientDepositHistoryList: FC = () => {
  const { id: clientId } = useRouteParams(
    ROUTES.admin.clients.details.deposits.list,
  );

  const { data: client } = useAdminClient(clientId);

  if (!client) return null;

  return client.settings.depositManagementMethod === 'clientAccount' ? (
    <AdminClientDepositHistoryListPerClient />
  ) : client.settings.depositManagementMethod === 'company' ? (
    <AdminClientDepositHistoryListPerCompany />
  ) : null;
};
